import { render } from "./risk-supply.vue?vue&type=template&id=03758770&scoped=true"
import script from "./risk-supply.vue?vue&type=script&lang=js"
export * from "./risk-supply.vue?vue&type=script&lang=js"

import "./risk-supply.vue?vue&type=style&index=0&id=03758770&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03758770"]])

export default __exports__